import axios from 'axios';
import PopupComponent from '../PopupComponent';

export default class WishlistPopup extends PopupComponent {
	constructor() {
		super({
			element: '.popup--wishlist',
			elements: {
				title: '#popup-wishlist-title',
				size: '#popup-wishlist-size',
				frame: '#popup-wishlist-frame',
				img: '.popup__product-image',
				form: '.popup__wishlist-form',
				emailInput: '#wishlist-email',
				btn: '#add-to-wishlist-btn',
			},
		});

		this.product = null;
		this.timer = null;
		this.timeSteps = 0;
		this.reqAttempts = 0;
		this.defaultBtnText = '';
	}

	insertProduct(product) {
		this.product = product;
		this.elements.title.innerHTML = product.title;
		this.elements.size.innerHTML = product.size.name;
		this.elements.frame.innerHTML = product.frame.name;
		this.elements.img.src =
			'images/store/' +
			product.number +
			'/' +
			'w507-' +
			product.images[0].src;
		this.elements.img.alt = product.images[0].alt || product.title;
	}

	getStrings() {
		const fjs = (typeof FRONTJS !== 'undefined' && FRONTJS) || {};
		const locale = (typeof window !== 'undefined' && window.locale) || 'en';
		const dict = fjs[locale] || {};
		return {
			loading: dict.wishlistloading || 'Sending...',
			success: dict.wishlistsuccess || 'Added to Wishlist!',
			error: dict.wishlisterror || 'Error!',
			defaultText: dict.addtowishlist || 'Add to Wishlist',
		};
	}

	errorTimer() {
		const strings = this.getStrings();
		if (this.reqAttempts > 2) {
			this.elements.btn.textContent = strings.error;
			return;
		}
		this.timer = setInterval(() => {
			this.timeSteps++;
			if (this.timeSteps > 5) {
				clearInterval(this.timer);
				this.animate('default');
				this.reqAttempts += 1;
				this.timer = null;
				this.timeSteps = 0;
			} else {
				this.elements.btn.textContent = `${strings.error} (${
					6 - this.timeSteps
				})`;
			}
		}, 1000);
	}

	animate(state) {
		const strings = this.getStrings();
		const btn = this.elements.btn;

		switch (state) {
			case 'loading':
				btn.classList.add('btn--disabled');
				btn.classList.remove('btn--success', 'btn--error');
				btn.textContent = strings.loading;
				break;
			case 'success':
				btn.classList.add('btn--disabled', 'btn--success');
				btn.classList.remove('btn--error');
				btn.textContent = strings.success;
				break;
			case 'error':
				btn.classList.add('btn--disabled', 'btn--error');
				btn.classList.remove('btn--success');
				btn.textContent = strings.error;
				this.errorTimer();
				break;
			case 'default':
				btn.classList.remove(
					'btn--disabled',
					'btn--success',
					'btn--error'
				);
				btn.textContent = this.defaultBtnText || strings.defaultText;
				break;
			default:
				break;
		}
	}

	async submitForm(e) {
		e.preventDefault();
		if (!this.product) return;

		const email = this.elements.emailInput.value.trim();
		if (!email) return;

		this.animate('loading');

		const payload = {
			email,
			product: {
				id: this.product.id,
				title: this.product.title,
				number: this.product.number,
				size: this.product.size && this.product.size.name,
				frame: this.product.frame && this.product.frame.name,
			},
			locale: window.locale,
		};

		try {
			await axios.post(FN_URL.wishlistCreate, payload);
			this.animate('success');
			this.elements.emailInput.value = '';
		} catch (error) {
			console.error('wishlist submit error:', error.message);
			this.animate('error');
		}
	}

	addEventListeners() {
		super.addEventListeners();
		this.defaultBtnText = this.elements.btn.textContent;
		this.elements.form.addEventListener('submit', (e) => this.submitForm(e));
	}

	show() {
		super.show();
		this.$emit('stopScroll');
	}

	hide(startScroll = true) {
		super.hide();
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
			this.timeSteps = 0;
		}
		this.reqAttempts = 0;
		this.animate('default');
		if (startScroll) this.$emit('startScroll');
	}
}
